import { createReducer } from 'app-webtech-core/reducers/createReducer';
import { SET_SEASON_ID } from '../actions/types';
import { vodSeasonIdReducer } from './seasonId';

export const defaultState = {
  seasonId: false,
};

export const vodReducer = createReducer(defaultState, {
  [SET_SEASON_ID]: vodSeasonIdReducer,
});
